<template>
  <div class="detail">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基本信息
          </div>
        </template>
        <div class="collapse-content">
          <BaseInfoForm
            :isDisabledForm="isDisabledForm"
            :fetchData="formData"
            ref="baseInfoFormRef"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="collapse-content">
          <FileTable
            ref="fileTableRef"
            :isShowDownBtn="isShowDownBtn"
            :isDisabledUpload="isDisabledUpload"
            :isDisabledDelete="isDisabledDelete"
            :attachments="attachments"
          />
        </div>
      </el-collapse-item>
      <!-- 底部按钮 -->
      <footer class="bottomButtons">
        <DetailFooterButtons @btnHandler="btnHandler"></DetailFooterButtons>
      </footer>
      <DeleteContractDialog ref="deleteContractRef" :deleteIds="deleteIds"></DeleteContractDialog>
      <CloseOrActivateDialog
        ref="closeOrActiveRef"
        :operateFlag="operateFlag"
        @confirmCloseOrActivate="closeOrActivateHandler"
      />
    </el-collapse>
  </div>
</template>

<script>
  import BaseInfoForm from './components/BaseInfoForm/index.vue';
  import FileTable from '@/components/business/FileTable/index.vue';
  import DetailFooterButtons from './components/DetailFooterButtons.vue';
  import DeleteContractDialog from './components/deleteContractDialog.vue';
  import CloseOrActivateDialog from './components/CloseOrActivateDialog.vue';
  import serviceApi from '@/api/purchaseSalesCenter/outerServiceContract.js';
  import btnGroupMixin from './btnGroupMixin';
  export default {
    name: 'serviceContractDetail',
    mixins: [btnGroupMixin],
    data() {
      return {
        activeNames: ['1', '2'],
        currentStatus: 'detail',
        isShowDownBtn: true, //附件批量下载按钮
        isDisabledUpload: false, //附件上传按钮
        isDisabledDelete: false, //附件删除按钮
        isDisabledForm: false, //表单是否可编辑
        isCopy: false, //是否为复制
        id: null,
        attachments: [],
        deleteIds: [],
        formData: {},
        operateFlag: null,
      };
    },
    mounted() {
      this.id = this.$route.query?.id;
      this.isCopy = this.$route.query?.isCopy;
      if (this.id) {
        this.initPageData(this.id);
      }
      if (this.$route.query?.status == 'create') {
        this.isDisabledForm = false;
        this.isShowDownBtn = false;
      } else if (this.$route.query?.status == 'detail') {
        this.isDisabledForm = true;
      }
    },
    methods: {
      // 初始化数据
      async initPageData(id) {
        this.isLoading = true;
        const { data } = await this.$axios.post(`${serviceApi.DETAIL_BY_ID}/${id}`);
        console.log(data, '根据id值查询这一行的数据');
        this.isLoading = false;
        if (data.code == 0) {
          const { attachments, ...formData } = data.data;
          this.attachments = attachments;
          this.formData = formData;
          this.formData.contractType = String(formData.contractType);
          this.formData.penaltyTypeValue =
            formData.penaltyTypeValue == null ? null : String(formData.penaltyTypeValue);
          this.formData.penaltyDailyRate =
            formData.penaltyDailyRate == null ? null : String(formData.penaltyDailyRate);
          this.formData.isViolationResponsibility = String(formData.isViolationResponsibility);
          if (
            formData.contractStatus == 'ZT00' ||
            formData.contractStatus == 'ZT061' ||
            formData.contractStatus == 'ZT05' ||
            formData.contractStatus == 'ZT051'
          ) {
            this.isShowDownBtn = false;
            this.isDisabledForm = false;
          }
        } else {
          console.error('获取数据失败');
        }
      },
    },
    components: {
      BaseInfoForm,
      DetailFooterButtons,
      DeleteContractDialog,
      CloseOrActivateDialog,
      FileTable,
    },
  };
</script>

<style lang="scss" scoped>
  .bottomButtons {
    padding-top: 20px;
    text-align: center;
  }
</style>
